import Skeleton from '@/components/dataDisplay/Skeleton';

const RouteCoverPlaceholder = () => (
  <div
    style={{ display: 'flex', flexDirection: 'column', gap: 16, flex: 1, justifyContent: 'space-between' }}
  >
    <div style={{ padding: 16 }}>
      <Skeleton width="100%" height="200px" />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skeleton width="100%" height="40px" />
        <Skeleton width="100%" />
        <Skeleton width="90%" />
        <Skeleton width="80%" />
        <Skeleton width="90%" />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Skeleton width="90%" height="30px" />
        <Skeleton width="80%" />
        <Skeleton width="80%" />
        <Skeleton width="80%" />
        <Skeleton width="80%" />
      </div>
    </div>
    <div style={{ padding: 16 }}>
      <Skeleton height={50} />
    </div>
  </div>
);

export default RouteCoverPlaceholder;
